module.exports = __webpack_public_path__ + "static/media/4.12.89ea5f0b.png";